import React, { useState } from 'react';
import { Sparkles, History as HistoryIcon } from 'lucide-react';
import { useTheme } from '../../../context/ThemeContext';
import RequestServicesWizard from '../../service-requests/RequestServicesWizard';
import ServiceRequestHistory from '../../service-requests/ServiceRequestHistory';

export default function RequestServicesPage() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [tab, setTab] = useState('new');
  const [draft, setDraft] = useState(null);

  const triggerRequestAgain = (clonedDraft) => {
    setDraft(clonedDraft);
    setTab('new');
  };

  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-medium font-rasa">Request a service</h1>
        <p className={`text-sm font-rasa mt-1 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          Tell us what you need and we'll route it to the right Zeffert team.
        </p>
      </div>

      <div className={`flex border-b mb-6 ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
        <button
          type="button"
          onClick={() => setTab('new')}
          className={`inline-flex items-center gap-2 py-2 px-4 font-medium font-rasa text-sm ${
            tab === 'new'
              ? 'text-blue-500 border-b-2 border-blue-500'
              : isDark ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <Sparkles size={14} /> New request
        </button>
        <button
          type="button"
          onClick={() => setTab('history')}
          className={`inline-flex items-center gap-2 py-2 px-4 font-medium font-rasa text-sm ${
            tab === 'history'
              ? 'text-blue-500 border-b-2 border-blue-500'
              : isDark ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <HistoryIcon size={14} /> History
        </button>
      </div>

      {tab === 'new' && (
        <RequestServicesWizard
          initialDraft={draft}
          onSubmitted={() => { setDraft(null); setTab('history'); }}
        />
      )}
      {tab === 'history' && (
        <ServiceRequestHistory onRequestAgain={triggerRequestAgain} />
      )}
    </div>
  );
}
